<template>
    <a :href="itemLink" class="cursor-pointer w-100 mx-2" ref="itemContainer" @click.prevent="goToDetail()">
        <!-- {{ item }} -->
        <div class="w-100 border border-1">
            <img class="img-fluid w-auto item-item-img" :src="primaryImageUrl" alt="" :style="{ height: (Number(getHight)/1.3)+'px' }">
            <!-- <div class="item-item-img bg-img-cover w-100 bg-white" :style="{ backgroundImage: `url(${primaryImageUrl})`, height: (Number(getHight)/1.3)+'px' }"></div> -->
        </div>
        <p class="fs-6 text-start ps-0 ps-lg-4 ps-md-2 pt-2"> {{ title }}</p>
        <p class="fs-6 text-start ps-0 ps-lg-4 ps-md-2" v-if="total.discountedPrice">
            <span class="">START FROM {{ itemCurrency }}</span>&nbsp;
            <del style="color: #F69320;"><span class="" style="color: #000;">{{ total.salesPrice }}</span></del> &nbsp;
            <span class="" style="color: #ea1a21 !important;">{{ total.discountedPrice }}</span> 
        </p>
        <p v-else class="fs-6 text-start ps-0 ps-lg-4 ps-md-2">START FROM {{ itemCurrency }} <strong>{{ total.salesPrice }}</strong></p>
    </a>
</template>

<script setup>
import { useItemDto } from '@/composables/useItemDto';
import { useCurrenciesStore } from "@/stores/currencies-store";
import {
    itemsV3Client,
    itemBundlesClient,
} from "@/assets/apis/config";
import { useGlobalDiscountStore } from "@/stores/global-discount-store";

const globalDiscountStore = useGlobalDiscountStore();
const currenciesStore = useCurrenciesStore();
const router = useRouter();
const props = defineProps({
    item: {
        type: Object,
        default: null,
    }
});

const itemRef = toRef(props, 'item');
const itemContainer = ref(null);

// const itemRef = computed(() => {
//     if (props.item?.item?.id?.length) {
//         console.log("props.item?.item?.id");
//         console.log(props.item?.item?.id);
//         return fetchData(props.item.item.id, 'item')
//     }
//     return null;
// });
// if (itemRef.value != null) {
const { id, primaryImageUrl, title, price, discountedSalesPrice, subscriptionPrice } = useItemDto(itemRef.value);
// }

const getHight = computed(()=> {
    if (itemContainer.value?.offsetWidth) {
        return itemContainer.value.offsetWidth < 600 ? itemContainer.value.offsetWidth : 500;
    }
    return 0
})

const itemLink = computed(() => {
    
    let link = "#";
    let ids = id.value ? id.value : "";
    if (ids) {
        link = `/details?id=${id.value}`;
    }
    return link;
});

const goToDetail = () => {
    router.push({
        name: 'details',
        query: {id: id.value}
    })
};

const itemCurrency = computed(() => {
    let currency = "BDT";
    if (
        currenciesStore.country &&
        currenciesStore.country.currency &&
        currenciesStore.country.currency.length > 0
    ) {
        currency = currenciesStore.country.currency;
    }

    return currency;
});


const globalDiscount = computed(() => {
    if (!props.item?.id) {
        return 0;
    }
    if (discountedSalesPrice.value > 0) {
        return discountedSalesPrice.value;
    }
    let discountPrice = 0;
    let salesPrice = Number(price.value);
    let categoryIds = itemRef.value?.categories;
    if (globalDiscountStore?.discounts?.length) {
        globalDiscountStore.discounts.forEach(element => {
            let discount = element.discountType === 'PERCENTAGE' ? Math.floor(salesPrice - salesPrice * Number(element.value) / 100) : salesPrice - Number(element.value);
            
            if (element.type === 'FIXED_CATEGORY' && element.valid) {
                categoryIds.forEach(category => {
                    let findItem = element?.categories?.length && element.categories.filter(i=> i.categoryId.replaceAll("-", "") === category.id.replaceAll("-", ""));
                    if (findItem.length) {
                        discountPrice = discount;
                    }
                });
            }

            if (element.type === 'FIXED_PRODUCT' && element.valid) {
                let findItem = element?.items?.length && element.items.filter(i=> i.itemId === props.item.id && !i?.skuCode?.length);
                if (findItem.length) {
                    discountPrice = discount;
                }
            }
        });
    }

    return discountPrice;
});

const total = computed(() => {
    let discountedPrice = 0;
    let salesPrice = 0;
    if (currenciesStore?.country?.currency != "BDT" &&
        currenciesStore?.country?.rate > 0
    ) {
        if (globalDiscount.value > 0) {
            discountedPrice = (
                Number(globalDiscount.value) /
                Number(currenciesStore.country.rate)
            ).toFixed(2);
        }
        if (price.value > 0) {
            salesPrice = (
                Number(price.value) /
                Number(currenciesStore.country.rate)
            ).toFixed(2);
        }
    } else {
        if (globalDiscount.value > 0) {
            discountedPrice = Number(globalDiscount.value);
        }
        if (price.value > 0) {
            salesPrice = Number(price.value);
        }
    }

    return {
        discountedPrice: discountedPrice,
        salesPrice: salesPrice,
    };
});

const fetchData = async (id, type) => {
    
    let item = ref(null);
    let res = null;
    if (type == 'item') {
        res = await itemsV3Client.findOneJoin({ id: id, fetchSkus: true });
    } else if (type == 'bundle') {
        res = await itemBundlesClient.findOneJoin({ id: id, fetchSkus: true, fetchItems: true, fetchSkuDetails: true});
    }

    if (res.networkError) {
        /* TODO: show message */
        return;
    }

    if (res.status == 200 && res.body) {
        let itemBody = res.body;
        let categories = itemBody?.categories?.length ? itemBody.categories.map(i => i.category) : [];
        let collections = itemBody?.collections?.length ? itemBody.collections.map(i => i.collection) : [];
        
        if (type == 'item') {
            item.value = {
                ...itemBody.item,
            }
        }
        if (type == 'bundle') {
            item.value = {
                ...itemBody.bundle,
                items: itemBody?.items,
                skuDetails: itemBody?.skuDetails,
            }
        }

        item.value.categories = categories;
        item.value.lookups = itemBody.lookups;
        item.value.keywords = itemBody.keywords;
        item.value.images = itemBody.attachments;
        item.value.skus = itemBody.skus;
        item.value.collections = collections;
    } else {
        return;
    }

    return item.value;
}
</script>

<style lang="scss">
.item-item-img {
    min-height: 300px;
}
</style>